import { Component, OnInit, AfterViewInit, ViewChild } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { UserService } from "../services/user.service";
import { ProcessingpService } from "../services/processing.service";
import { POService } from "../services/po.service";
import { ImageService } from "../services/image.service";
import { Methods } from "../shared/methods";
import { DinamicData, Cell } from "../models/dinamic-data";
import { GuiGuard } from "../shared/guard/base-gui-guard";
import { ConfigService } from "../services/config.service";
import { Icon } from "../models/card-icon";
import { CitaService } from "../services/cita.service";
import { CreatePiComponent } from "../processing-instructions/create-pi/create-pi.component";
import { TitleService } from '../services/title.service';
import swal from "sweetalert2";
import { lastValueFrom } from 'rxjs';
declare var $: any;

declare interface option {
  colName: string;
  position: number;
  visibility: boolean;
  origin: number;
}

@Component({
  selector: "app-processing-instructions",
  templateUrl: "./processing-instructions.component.html",
  styleUrls: ["./processing-instructions.component.css"],
  providers: [
    UserService,
    ProcessingpService,
    POService,
    ImageService,
    CitaService,
    CreatePiComponent,
  ],
})
export class ProcessingInstructionsComponent implements OnInit {
  @ViewChild(CreatePiComponent)
  child: CreatePiComponent;
  iconTitle: Icon = {
    icon: "account_tree",
    title: "Processing Instructions",
  };

  public mtds: Methods = new Methods();

  public identity;
  public token;
  public selectId: number;
  public crud: string;
  public loading: boolean;

  public estatus = "ALL";

  public data;
  public busqueda = "";
  public esbusqueda = false;
  public type = "ALL";
  public manifestStatus = "ALL";
  public companyLinked = null;
  public hasPickups = false;
  public apikey = "";
  public btnExcel = [];
  public apiCompany;
  public statuses= [
    { value: 'All', label: 'All' },
    { value: 'In Transit', label: 'In Transit' },
    { value: 'Picked Up', label: 'Picked Up' },
    { value: 'Received', label: 'Received' },
    { value: 'In Manifest', label: 'In Manifest' },
    { value: 'In Testing', label: 'In Testing' },
    { value: 'In Sales', label: 'In Sales' },
    { value: 'Processed', label: 'Processed' },
    { value: 'Voided', label: 'Voided' },
  ];  
  
    public selectedStatuses: string[] = [];
    //
    public optionsButtonSelect;
    public optionSelectMenuTrigger;
  public params;

  public show_crudModalDetail: boolean = false;
  public show_crudModal: boolean = false;

  public options: Array<option> = [];

  public tablekey: string;

  public processingList: DinamicData = new DinamicData([
    "Id",
    "PO",
    "Client Name",
    "Buyer",
    "Last Update",
    "Status",
    "Payment Status",
    "HDD Status",
    "Date Received",
    "Manifest",
    "Manifest Status",
    "Testing Priority Level",
    "Testing Status",
    "Sales Rep",
    "Manifest Rep",
    "Tech Rep",
    "Actions",
  ]);

  public status_filtro:any = ['Pending'];

  public esgReportingRequired;
  public po_id;
  constructor(
    private titleService: Title,
    private _router: Router,
    private _route: ActivatedRoute,
    private _userService: UserService,
    private _imageService: ImageService,
    public gui: GuiGuard,
    private _processingSerice: ProcessingpService,
    private _configTable: ConfigService,
    private _citaService: CitaService,private titleServices: TitleService,
  ) {
    this.tablekey = this.gui.permissions("tableProcessingClientName")
      ? "porcessingList"
      : "porcessingInstructions";

    console.log(this.tablekey);

    this.titleService.setTitle("Processing Instructions");
    this.identity = this._userService.getIdentity();
    this.selectId = 3;
    this.crud = "create";
    this.loading = false;
    this.token = this._userService.getToken();

    this.apikey = this.identity.apiCompany;

    this._userService.getUser(this.token, this.identity.sub).subscribe(
      (response) => {
        console.log(response);
        if (response.status == "success") {
          this.companyLinked = response.data.companyLinked;
          console.log(this.companyLinked);
          this.apiCompany = response.data.companyLinked.apiToken;
        }
      },
      (error) => {
        console.log(<any>error);
      }
    );
  }
  menuTriggerToShow(newValue: string) {
    this.optionSelectMenuTrigger = newValue; 
    this.getList();
  }
  /*  */
  private latestRequestId = 0;
  async loadDataAsync(params?: any): Promise<void> {
    // Incrementa el contador global para identificar la nueva solicitud
    this.latestRequestId++;
    const currentRequestId = this.latestRequestId;
    this.data.rows = [];
    this.loading = true;
    try {
      const json = {
        status_default: this.selectedStatuses,
        sort: [this.filterrigh],
        order: this.sortStates
      };

      // Llama al servicio y espera la respuesta
      const response = await lastValueFrom(
        this._processingSerice.getAllOpti(
          this.token,
          this.paginaActual,
          this.estatus,
          this.itemsPorPagina,
          this.busqueda,
          this.type,
          this.manifestStatus,
          this.sort.toUpperCase(),
          this.sortby,
          '',
          this.filtros,
          json
        )
      );
      if (currentRequestId !== this.latestRequestId) {
        console.log('Respuesta antigua ignorada');
        return;
      }
      this.processingList = this.transformResponseToDinamicData(response);
    } catch (error: any) {
      this.mtds.notifyError(error.statusText, error.status);
    } finally {
      // Solo actualiza el flag de loading si esta fue la última solicitud
      if (currentRequestId === this.latestRequestId) {
        this.loading = false;
      }
    }
  }
  private transformResponseToDinamicData(response: any): DinamicData {
    const headers = [...this.processingList.headers]; // O define tus headers
    const rows = [];
    this.paginaActual = Number(response.page_actual);
    this.itemsPorPagina = String(response.items_per_page);
    this.totalItems = Number(response.total_items_count);
    this.totalPaginas = Number(response.total_pages);
    this.sort = String(response.order).toLowerCase();
    this.sortby = null;
    for (let i = 0; i <= this.filtros.length; i++) {
      if (this.filtros[i] && this.filtros[i].key === response.orderby) {
        this.sortby = i;
        break;
      }
    }
    for (let element of response.data) {
      let actionButtons = [];
      if (
        this.identity.role != "VENDOR" &&
        this.identity.role != "customer" &&
        element.status == "INTRANSIT"
      ) {
        actionButtons.push({
          icon: "delete_outline",
          action: "delete",
          color: "danger",
          value: { id: element.id, po: element.po.po },
        });
      }

      if (this.hasContainer(element)) {
        actionButtons.push({
          icon: "perm_scan_wifi",
          action: "container",
          color: "default",
          value: element.po.po,
        });
      }

      if (element.chatLogs) {
        actionButtons.push({
          icon: "chat_bubble",
          action: "chat",
          color: "warning",
          value: element.id,
        });
      }
      if (!element.esgReportingRequired) {
        actionButtons.push({
          icon: "remove_red_eye",
          action: "show",
          color: "info",
          value: element.id,
        });
      } else {
        actionButtons.push({
          icon: "remove_red_eye",
          action: "showDetail",
          color: "warning",
          value: element.id,
        });
      }

      actionButtons.push({
        icon: "local_printshop",
        action: "print",
        color: "primary",
        value: element.id,
      });
      const row = [
        new Cell(element.id),
        new Cell(element.po.po, { class: "fs-5 fw-bold" }),
        new Cell(element.clientName),
        new Cell(
          element.rep ? element.rep.name + " " + element.rep.surname : ""
        ),
        /*
        new Cell(
          element.updatedAt !== null
            ? this.mtds.getFecha(
                new Date(element.updatedAt.timestamp * 1000),
                "MM-dd-yyyy"
              )  
            : ""
        ),
        */
        new Cell(this.formatDateTimeUS(element.updatedAt)),
        new Cell(this.status(element)),
        new Cell(this.paidStatus(element)),
        new Cell(
          ` ${element.batchCompleted} / ${element.batchTotal} Completed`
        ),
        new Cell(
          element.dateFirstReceived !== null &&
          element.dateFirstReceived.timestamp !== -62169962964
            ? /*this.mtds.getFecha(
                new Date(element.dateFirstReceived.timestamp * 1000),
                "MM-dd-yyyy"
              )
              */
          this.formatDateTimeUS(element.dateFirstReceived)
            : ""
        ),
        new Cell(
          element.manifestRequired == "Yes" ||
          element.manifestRequired == "yesDetailedManifest"
            ? this.showmanifest(element)
            : element.manifestRequired == "No" ||
              element.manifestRequired == "noCertificateDisposalOnly" ||
              element.manifestRequired == "noReportingRequired"
            ? this.showNomanifest(element)
            : ""
        ),
        new Cell(element.manifestStatus),
        new Cell(this.testingPriorityLevel(element.poPriorityLevel)),
        new Cell(element.testingStatus),
        new Cell(
          element.sales !== null
            ? element.sales.name[0] + element.sales.surname[0]
            : "--"
        ),
        new Cell(
          element.manifest !== null
            ? element.manifest.name[0] + element.manifest.surname[0]
            : "--"
        ),
        new Cell(
          element.tech !== null
            ? element.tech.name[0] + element.tech.surname[0]
            : "--"
        ),
        new Cell(actionButtons, {
          type: "actions",
          class: "white-space-nowrap",
        }),
      ];
      rows.push(row);
    }
    let ids =
    "https://www.itaderp.com/backend/reports/download-processing-report.php?idprocessing=",
  first = true;

for (let item of response.data) {
  if (first) {
    ids = ids + String(item.id);
    first = false;
  } else {
    ids = ids + "-" + String(item.id);
  }
}

ids = ids + "&apitoken=" + this.apiCompany;

this.btnExcel = [
  {
    text: '<span class="gts-btn-icon">table_view</span>',
    titleAttr: "Excel",
    className: "gts-btn-primary-outline-actions-start",
    action: function () {
      window.open(ids);
    },
  },
];
    return new DinamicData(headers, rows);
  }
  /*  */
  public previousStatuses: string[] = [];
  onStatusChange(event: any): void {

    /* this.selectedStatuses = event.value; */
    let newSelection = event.value as string[];
  

    if (!this.previousStatuses.includes('All') && newSelection.includes('All')) {
      newSelection = ['All'];
    }

    else if (this.previousStatuses.includes('All') && newSelection.length > 1) {
      newSelection = newSelection.filter(status => status !== 'All');
    }

    if (newSelection.length === 0) {
      newSelection = ['All'];
    }

    this.selectedStatuses = newSelection;
    this.previousStatuses = [...newSelection]; 
    this.loadDataAsync();
  }

  ngOnInit() {
    this.statuses= [
      { value: 'All', label: 'All' },
      { value: 'In Transit', label: 'In Transit' },
      { value: 'Picked Up', label: 'Picked Up' },
      { value: 'Received', label: 'Received' },
      { value: 'In Manifest', label: 'In Manifest' },
      { value: 'In Testing', label: 'In Testing' },
      { value: 'In Sales', label: 'In Sales' },
      { value: 'Processed', label: 'Processed' },
      { value: 'Voided', label: 'Voided' },
    ];
    this.optionSelectMenuTrigger='INTRANSIT';
   this.selectedStatuses = this.statuses
   .filter(
     (status) => status.value !== 'Voided' && status.value !== 'Processed' && status.value !== 'All'
   )
   .map((status) => status.value);

    let me = this;
    this.loading = true;
    this._configTable.getConfig(this.tablekey).subscribe(
      (r: any) => {
        console.log(r);
        if (r.data) {
          this.options = JSON.parse(r.data.data);
          console.log(this.options);
          this.itemsPorPagina = r.data.pageLimit;
        } else {
          switch (this.tablekey) {
            case "porcessingList":
              this.options = this.mtds.colopt(this.processingList.headers, [
                false,
              ]);
              break;
            case "porcessingInstructions":
              this.options = this.mtds.colopt(this.processingList.headers, [
                false,
              ]);
              break;
            default:
              break;
          }
        }
        this.getList();
        this._route.params.subscribe((params) => {
          if (params["id"]) {
            this.po_id = params["id"];

            this._processingSerice
              .getOne(this.token, this.po_id)
              .subscribe((response) => {
                if (
                  response.code === 400 &&
                  response.msg === "Authorization not valid"
                ) {
                  this.mtds.notifyError("Your session has expired");
                  localStorage.clear();
                  this._router.navigate(["/pages/lock"]);
                } else if (response.code === 404) {
                  history.pushState(null, "", "processing-instructions");
                } else if (response.status == "success") {
                  this.esgReportingRequired =
                    response.data.esgReportingRequired;
                  if (this.esgReportingRequired) {
                    this.show_crudModalDetail = true;
                    this.openModalDetail("read", this.po_id);
                  } else if (
                    !this.esgReportingRequired ||
                    this.esgReportingRequired === null
                  ) {
                    this.show_crudModal = true;
                    this.openModal("read", this.po_id);
                  }
                }
              });
          }
        });
      },
      (error) => {
        this.mtds.notifyError(error.statusText, error.status);
        this.loading = false;
      }
    );

    $("#crudModal").on("hide.bs.modal", function (e) {
      console.log("modal is closed");
      me.closeModal(false);
      me.cleanParams();
    });

    $("#crudModalDetail").on("hide.bs.modal", function (e) {
      console.log("modal is closed");
      me.closeModal(false);
      me.cleanParams();
    });
    this.titleServices.setTitle('Processing Instructions');
  }
  stopPropagation(event: WheelEvent): void {
    // Prevent the scroll event from bubbling up to the parent element
    event.stopPropagation();
  }
  get selectedStatusesLabel(): string {
    // Asumiendo que `selectedStatuses` sea un array de strings
    return (this.selectedStatuses || []).join(', ');
  }
  public filterrigh = "";
  public sortStates = ""; 
  handleRightClick(data: any): void {
    const columnKey = data.columnName.key;
    if(columnKey === this.filterrigh ){
      if(this.sortStates === "DESC"){
        this.sortStates = "ASC"
      }else{
        this.sortStates = "DESC"
      }
    } else{
      this.sortStates = "ASC"
    }
    this.filterrigh = columnKey;

    this.getList();
  }
  cleanParams() {
    this._router.navigate(["/processing-instructions"]);

    /*const currentUrl = this._router.url;
    const queryParams = this._router.parseUrl(currentUrl).queryParams;

    // Remove the parameter you want to remove (e.g., 'paramToRemove')
    delete queryParams['ticket'];

    // Navigate to the same route without the removed parameter
    this._router.navigate([], {
      queryParams,
      queryParamsHandling: 'merge'
    });*/

    /*const params = { ...this._route.snapshot.queryParams };
    console.log(params);
    delete params.ticket;
    delete params.id;
    this._router.navigate([], { queryParams: params });
    this._router.navigate([], { queryParams: {} });

    this._router.navigate([], {
      relativeTo: this._route,
      queryParams: null,
      queryParamsHandling: 'merge'
    });

    this._route.params.subscribe((params) => {
      console.log(params);     
    });*/
  }

  updateConfig(e) {
    this.options = e;
    console.log(this.options);
    this._configTable.setConfig(this.tablekey, this.options).subscribe((r) => {
      console.log(r);
    });
  }

  cambiar(s: string) {
    if(s == 'All'){
      /*if (this.status_filtro.includes(s)){
        this.status_filtro = [];
      } else {*/
        this.status_filtro = [];
        this.status_filtro.push('All');
      //}
      
    } else {
      this.status_filtro = this.status_filtro.filter(item => item !== 'All');



      if (this.status_filtro.includes(s)) {
         if(this.status_filtro.length == 1) return false;
          // Si 's' ya está en el array, lo quitamos
          this.status_filtro = this.status_filtro.filter(item => item !== s);
      } else {
          // Si 's' no está en el array, lo agregamos
          this.status_filtro.push(s);
      }
    }
    this.getList();
  }

  action(e) {
    //console.log("action=>",e);
    switch (e.action) {
      case "show": {
        this.show_crudModal = true;
        this.openModal("read", e.id);
        break;
      }
      case "showDetail": {
        this.show_crudModalDetail = true;
        this.openModalDetail("read", e.id);
        break;
      }
      case "showtest": {
        this.openModal("read", e.id);
        break;
      }
      case "print": {
        this.openReport(e);
        break;
      }
      case "delete": {
        swal
          .fire({
            title: "Remove Processing Instruction",
            text: `Are you sure you want to delete processing instruction # ${e.id.po}?`,
            showCancelButton: true,
            confirmButtonText: "Continue",
            cancelButtonText: "Cancel",
            customClass: {
              confirmButton: "btn btn-danger",
              cancelButton: "btn btn-default",
            },

            buttonsStyling: false,
          })
          .then((request) => {
            if (request.value) {
              this._processingSerice.delete(this.token, e.id.id).subscribe(
                (r) => {
                  if (r.code === 400 && r.msg === "Authorization not valid") {
                    this.mtds.notifyError("Your session has expired");
                    localStorage.clear();
                    this._router.navigate(["/pages/lock"]);
                  } else if (r.status === "success") {
                    this.getList(this.parametros);
                    swal.fire({
                      title: "Done!",
                      text: `Processing Instruction # ${e.id.id} has been successfully removed`,
                      buttonsStyling: false,
                      customClass: {
                        confirmButton: "btn btn-success",
                      },
                    });
                    if (this.child) {
                      this.child.sync();
                    }
                  } else {
                    this.mtds.notifyError(r.msg, r.code);
                  }
                },
                (error) => {
                  this.mtds.notifyError(error.statusText, error.status);
                }
              );
            }
          });
        break;
      }
      case "chat": {
        this.logs = true;
        this.openModal("read", e.id);
        break;
      }
      case "container": {
        window.open("/container-inventory/filter/" + e.id);
      }
    }
  }

  public parametros = null;
  public paginaActual = 1;
  public itemsPorPagina = "10";
  public totalItems = 0;
  public totalPaginas = 1;
  public sortby = null;
  public sort = "desc";

  public filtros = [
    null,
    {
      key: "po",
      title: "PO",
      value: "",
      type: "contains",
      key_type: "po_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "client_name",
      title: "Client Name",
      value: "",
      type: "contains",
      key_type: "client_name_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "buyer",
      title: "Buyer",
      value: "",
      type: "contains",
      key_type: "buyer_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "last_update",
      title: "Last Update",
      value: "",
      type: "startswith",
      key_type: "last_update_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "status",
      title: "Status",
      value: "",
      type: "contains",
      key_type: "status_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "payment_status",
      title: "Payment Status",
      value: "",
      type: "contains",
      key_type: "payment_status_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "hdd_status",
      title: "HDD Status",
      value: "",
      type: "",
      key_type: "hdd_status_type",
      type_options: [],
    },
    {
      key: "date_received",
      title: "Date Received",
      value: "",
      type: "startswith",
      key_type: "date_received_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "manifest",
      title: "Manifest",
      value: "",
      type: "contains",
      key_type: "manifest_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "manifest_status",
      title: "Manifest Status",
      value: "",
      type: "contains",
      key_type: "manifest_status_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "testing_priority_level",
      title: "Testing Priority Level",
      value: "",
      type: "contains",
      key_type: "testing_priority_level_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "testing_status",
      title: "Testing Status",
      value: "",
      type: "contains",
      key_type: "testing_status_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "sales_rep",
      title: "Sales Rep",
      value: "",
      type: "contains",
      key_type: "sales_rep_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "manifest_rep",
      title: "Manifest Rep",
      value: "",
      type: "contains",
      key_type: "manifest_rep_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "tech_rep",
      title: "Tech Rep",
      value: "",
      type: "contains",
      key_type: "tech_rep_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
  ];

  getList(params: any = null) {
    console.log(params);

    if (params === null) {
      this.busqueda = "";
      this.esbusqueda = false;
      this.sortby = null;
      this.sort = "desc";
      this.paginaActual = 1;
      //this.itemsPorPagina = "10";
    } else {
      console.log(params);
      this.parametros = params;
      this.sort = params.order;
      this.sortby = params.sortby;
      this.paginaActual = params.page;
      this.itemsPorPagina = params.perPage;
      this.esbusqueda = params.esbusqueda;
      this.busqueda = params.search;
    }

    if (this.estatus !== "MANIFESTREQUIRED") {
      this.type = "ALL";
    }
    let json = { status_default: this.selectedStatuses, sort :[this.filterrigh], order:this.sortStates };
    this.loading = true;
    this._processingSerice
      .getAllOpti(
        this.token,
        this.paginaActual,
        this.estatus,
        this.itemsPorPagina,
        this.busqueda,
        this.type,
        this.manifestStatus,
        this.sort.toUpperCase(),
        this.sortby,
        "",
        this.filtros,
        json
      )
      .subscribe(
        (response) => {
          console.log("getAll response => ", response);
          this.data = response;

          this.paginaActual = Number(response.page_actual);
          this.itemsPorPagina = String(response.items_per_page);
          this.totalItems = Number(response.total_items_count);
          this.totalPaginas = Number(response.total_pages);
          this.sort = String(response.order).toLowerCase();
          this.sortby = null;
          for (let i = 0; i <= this.filtros.length; i++) {
            if (this.filtros[i] && this.filtros[i].key === response.orderby) {
              this.sortby = i;
              break;
            }
          }

          this.processingList.rows = [];

          for (let element of response.data) {
            // console.log(element);
            /*
          esto no aplica porque no siempre se encontrara el po_id en la lista de getall debido al paginado
            if (this.po_id == element.id) {
              this.esgReportingRequired = element.esgReportingRequired;
            }*/
            /*
Esta validacion la hacemos desde backend, si tiene alguna pickup el backend regresa error
            this._citaService
              .getListByPO(this.token, element.po.id)
              .subscribe((r) => {
                console.log("getListByPO r => ", r);
                if (r.status === "success") {
                  const response = r.data;
                  let hasp = false;
                  r.data.length > 0 ? (hasp = true) : (hasp = false);
                  this.hasPickups = hasp;

                  if (
                    this.identity.role != "VENDOR" &&
                    this.identity.role != "customer" &&
                    element.status == "INTRANSIT" &&
                    this.hasPickups == false
                  ) {
                    actionButtons.push({
                      icon: "delete_outline",
                      action: "delete",
                      color: "danger",
                      value: { id: element.id, po: element.po.po },
                    });
                  }
                }
              });*/
            let actionButtons = [];
            if (
              this.identity.role != "VENDOR" &&
              this.identity.role != "customer" &&
              element.status == "INTRANSIT"
            ) {
              actionButtons.push({
                icon: "delete_outline",
                action: "delete",
                color: "danger",
                value: { id: element.id, po: element.po.po },
              });
            }

            if (this.hasContainer(element)) {
              actionButtons.push({
                icon: "perm_scan_wifi",
                action: "container",
                color: "default",
                value: element.po.po,
              });
            }

            if (element.chatLogs) {
              actionButtons.push({
                icon: "chat_bubble",
                action: "chat",
                color: "warning",
                value: element.id,
              });
            }
            if (!element.esgReportingRequired) {
              actionButtons.push({
                icon: "remove_red_eye",
                action: "show",
                color: "info",
                value: element.id,
              });
            } else {
              actionButtons.push({
                icon: "remove_red_eye",
                action: "showDetail",
                color: "warning",
                value: element.id,
              });
            }

            actionButtons.push({
              icon: "local_printshop",
              action: "print",
              color: "primary",
              value: element.id,
            });
            // console.log(element.id, this.hasPickups)
            //             if (
            //   this.identity.role != 'VENDOR' &&
            //   this.identity.role != 'customer' &&
            //   element.status == 'INTRANSIT' &&
            //   this.hasPickups == false
            // ) {
            //   actionButtons.push({ icon: 'delete_outline', action: 'delete', color: 'danger', value: { id: element.id, po: element.po.po} });
            // }

            this.processingList.rows.push([
              new Cell(element.id),
              new Cell(element.po.po, { 
                class: `fs-5 fw-bold ${
                  element.vipStatus == 1 
                    ? 'text-gold' 
                    : (element.processingCount != null && element.processingCount <= 5 
                        ? 'text-danger' 
                        : '')
                }` 
              }),
              new Cell(element.clientName),
              new Cell(
                element.rep ? element.rep.name + " " + element.rep.surname : ""
              ),
              /*new Cell(
                element.updatedAt !== null
                  ? this.mtds.getFecha(
                      new Date(element.updatedAt.timestamp * 1000),
                      "MM-dd-yyyy"
                    )
                  : ""
              )*/
                new Cell(this.formatDateTimeUS(element.updatedAt))
              ,
              new Cell(this.status(element)),
              new Cell(this.paidStatus(element)),
              new Cell(
                ` ${element.batchCompleted} / ${element.batchTotal} Completed`
              ),
              new Cell(
                element.dateFirstReceived !== null &&
                element.dateFirstReceived.timestamp !== -62169962964
                  ? /*this.mtds.getFecha(
                      new Date(element.dateFirstReceived.timestamp * 1000),
                      "MM-dd-yyyy"
                    )*/
                      this.formatDateTimeUS(element.dateFirstReceived)
                  : ""
              ),
              new Cell(
                element.manifestRequired == "Yes" ||
                element.manifestRequired == "yesDetailedManifest"
                  ? this.showmanifest(element)
                  : element.manifestRequired == "No" ||
                    element.manifestRequired == "noCertificateDisposalOnly" ||
                    element.manifestRequired == "noReportingRequired"
                  ? this.showNomanifest(element)
                  : ""
              ),
              new Cell(element.manifestStatus),
              new Cell(this.testingPriorityLevel(element.poPriorityLevel)),
              new Cell(element.testingStatus),
              new Cell(
                element.sales !== null
                  ? element.sales.name[0] + element.sales.surname[0]
                  : "--"
              ),
              new Cell(
                element.manifest !== null
                  ? element.manifest.name[0] + element.manifest.surname[0]
                  : "--"
              ),
              new Cell(
                element.tech !== null
                  ? element.tech.name[0] + element.tech.surname[0]
                  : "--"
              ),
              new Cell(actionButtons, {
                type: "actions",
                class: "white-space-nowrap",
              }),
            ]);
          }

          let ids =
              "https://www.itaderp.com/backend/reports/download-processing-report.php?idprocessing=",
            first = true;

          for (let item of response.data) {
            if (first) {
              ids = ids + String(item.id);
              first = false;
            } else {
              ids = ids + "-" + String(item.id);
            }
          }

          ids = ids + "&apitoken=" + this.apiCompany;

          this.btnExcel = [
            {
              text: '<span class="gts-btn-icon">table_view</span>',
              titleAttr: "Excel",
              className: "gts-btn-primary-outline-actions-start",
              action: function () {
                window.open(ids);
              },
            },
          ];

          if (
            response.code === 400 &&
            response.msg === "Authorization not valid"
          ) {
            this.mtds.notifyError("Your session has expired");
            localStorage.clear();
            this._router.navigate(["/pages/lock"]);
          } else if (response.status !== "success") {
            this.mtds.notifyError(response.msg, response.code);
          }
          this.loading = false;
          // console.log("getlist() this.po_id => ", this.po_id);
          // console.log("getlist() esgReportingRequired => ", this.esgReportingRequired);

          /*
  no aplica aqui
          if (this.po_id) {
            if (this.esgReportingRequired) {
              this.show_crudModalDetail = true;
              this.openModalDetail("read", this.po_id);
            }
            else if (!this.esgReportingRequired) {
              this.show_crudModal = true;
              this.openModal("read", this.po_id);
            }
          }*/
        },
        (error) => {
          this.loading = false;
          this.mtds.notifyError(error.statusText, error.status);
        }
      );
  }


  formatDateTimeUS(dateString: string | null): string {
    if (!dateString) return ''; 
  
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return ''; 
  
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear();
  
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
  
    return `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`;
  }


  public aguante = false;
  public logs = false;

  openModal(crud = "create", id = null) {
    this.show_crudModal = true;
    this.crud = crud;
    this.selectId = id;
    $("#crudModal").modal("show");

    this.aguante = true;
    setTimeout(
      function () {
        this.aguante = false;
      }.bind(this),
      250
    );
  }
  openModalDetail(crud = "create", id = null) {
    this.show_crudModalDetail = true;
    this.crud = crud;
    this.selectId = id;
    $("#crudModalDetail").modal("show");

    this.aguante = true;
    setTimeout(
      function () {
        this.aguante = false;
      }.bind(this),
      250
    );
  }
  public showModalPI: boolean = false;
  openModalCreate(crud = "create", id = null) {
    this.showModalPI = true;
    this.crud = crud;
    this.selectId = id;
    $("#modalPI").modal("show");
  }

  hasContainer(pi) {
    if (
      pi.numInmanifest !== 0 ||
      pi.numInmanifestFour !== 0 ||
      pi.numInmanifestSecond !== 0 ||
      pi.numInmanifestThird !== 0 ||
      pi.numInsales !== 0 ||
      pi.numInsalesFour !== 0 ||
      pi.numInsalesSecond !== 0 ||
      pi.numInsalesThird !== 0 ||
      pi.numIntesting !== 0 ||
      pi.numIntestingFour !== 0 ||
      pi.numIntestingSecond !== 0 ||
      pi.numIntestingThird !== 0 ||
      pi.numReceived !== 0 ||
      pi.numReceivedFour !== 0 ||
      pi.numReceivedSecond !== 0 ||
      pi.numReceivedThird !== 0
    ) {
      return true;
    }

    return false;
  }

  testingPriorityLevel(tpl) {
    switch (tpl) {
      case "LOWPRIORITY":
        return "Low";
      case "MEDIUMPRIORITY":
        return "Medium";
      case "FASTPRIORITY":
        return "Fast";
      case "URGENTPRIORITY":
        return "Urgent Same Day";
      default:
        return tpl;
    }
  }

  showmanifest(e) {
    let manifest = e.manifestPriorityLevel;
    if (manifest == "LOWPRIORITY") manifest = "Low Priority - 30 Days";
    else if (manifest == "NOMANIFEST") manifest = "No Manifest";
    else if (manifest == "URGENTPRIORITY") manifest = "Urgent Same Day - 1 Day";
    else if (manifest == "MEDIUMPRIORITY")
      manifest = "Medium Priority - 15 Days";
    else if (manifest == "FASTPRIORITY") manifest = "Fast Priority - 7 Days";
    return manifest;
  }
  showNomanifest(e) {
    let manifest = e.noManifestPriorityLevel;
    return manifest;
  }

  paidStatus(e) {
    let status = "Paid";
    if (e.isPaid == 0 || e.isPaid == null) status = "Pending";

    if (e.netTerms == "SORTANDSETTLE" && (e.isPaid == 0 || e.isPaid == null))
      status = "S&S";
    else if (
      e.netTerms == "REVENUESHARE" &&
      (e.isPaid == 0 || e.isPaid == null)
    )
      status = "RS";
    return status;
  }

  status(e) {
    let status = "";
    if(e.status == 'Voided'){
      status = 'Voided';
      return status;
    } 
    if (e.status === 'RECEIVED') {
      status = 'Received';
      return status;
    }
    if (e.numReceived > 0 || e.numReceivedSecond > 0) {
      status = "Received";
    }
    if (e.numInmanifest > 0 || e.numInmanifestSecond > 0) {
      status = status + (status != "" ? "/" : "") + "In Manifest";
    }
    if (e.numIntesting > 0 || e.numIntestingSecond > 0) {
      status = status + (status != "" ? "/" : "") + "In Testing";
    }
    if (e.numInsales > 0 || e.numInsalesSecond > 0) {
      status = status + (status != "" ? "/" : "") + "In Sales";
    }
    if (e.numProcessed > 0 || e.numProcessedSecond > 0) {
      status = status + (status != "" ? "/" : "") + "Processed";
    }

    if (status == "") {
      status = e.status;
    }
    if (status == "INTRANSIT") {
      status = "In Transit";
    } else if (status == "INTESTING") {
      status = "In Testing";
    } else if (status == "PROCESSED") {
      status = "Processed";
    } else if (status == "RECEIVED") {
      status = "Received";
    } else if (status == "PICKEDUP") {
      status = "Picked up";
    }

    return status;
  }

  openReport(reporteID) {
    window.open(
      "https://www.itaderp.com/backend/reports/print-processing-instructions.php?id=" +
        reporteID.id +
        "&apikey=" +
        this.apikey,
      "_blank"
    );
  }

  closeModal(reload: boolean = false) {
    this.selectId = null;
    this.crud = "create";
    this.logs = false;
    this.po_id = null;
    this.show_crudModalDetail = false;
    this.show_crudModal = false;
    if (reload) {
      this.getList(this.parametros);
    }
    history.pushState(null, "", "processing-instructions");
    // window.location.reload();
  }
  closeModalPI() {
    this.showModalPI = false;
    this.po_id = null;
    $("#modalPI").modal("hide");
    this.show_crudModalDetail = false;
    this.show_crudModal = false;
    this.getList(this.parametros);
    this.child.getCatalogos();
  }

  save(f) {
    this.closeModal(f);
    this.loading = false;
  }

  delete(id) {
    this._processingSerice.delete(this.token, this.selectId).subscribe(
      (response) => {
        if (
          response.code === 400 &&
          response.msg === "Authorization not valid"
        ) {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        } else if (response.status == "success") {
          swal.fire({
            title: "Processing Instruction has been successfully removed",
            text: "",
            buttonsStyling: false,
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
          this.closeModal(true);
        } else {
          this.closeModal(false);
          this.mtds.notifyError(response.msg, response.code);
        }
      },
      (error) => {
        this.closeModal(false);
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
  }

  getFecha(fecha: Date) {
    let dia;
    dia = fecha.getDate();
    let day;
    if (dia < 10) {
      day = "0" + dia;
    } else {
      day = dia;
    }
    let mes;
    mes = fecha.getMonth() + 1;
    let month;
    if (mes < 10) {
      month = "0" + mes;
    } else {
      month = mes;
    }
    let anio = fecha.getFullYear();

    return anio + "-" + month + "-" + day;
  }
}
